import { gql } from 'apollo-boost'

const SCRAPING_LOGS_MENUS_FOR_SESSION = gql`
  query scrapingLogsMenusForSessionId($sessionId: ID!) {
    scrapingLogsMenusForSessionId(sessionId: $sessionId) {
      menuId
      menuUrl
    }
  }
`

export default SCRAPING_LOGS_MENUS_FOR_SESSION
